/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop, propValidator } from '@prz-dp/services';

import CountryUtils from '@/modules/main/utils/country';

/**
 * Model `SearchFormModel`.
 */
@endpoint('address/search')
export default class SearchFormModel extends BaseModel {
  /**
   * Properties.
   */
  @prop({ required: true })
  city: string;

  @prop({ required: true })
  doorNumber: string;

  @prop({ required: true })
  street: string;

  @prop({ required: true })
  @propValidator(
    'valid:zipcodeformat',
    (value: string) => CountryUtils.isZipCodeValid(value),
    { i18nMessage: 'TRACKING.ERRORS.ZIP_CODE_WRONG_FORMAT' }
  )
  zipCode: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<SearchFormModel>) {
    super(data);
  }
}
